<template>
<div>
    <div
        class="label"
    >
        {{label}}
    </div>
    <div
        class="value"
    >
        <div 
            ref="my_code_block"
            class="text"
        >
            {{value}}
        </div>
        <div
            class="icon"
        >
            <v-icon
                v-on:click="onClickCopy"
            >
                {{copy_icon}}
            </v-icon>
        </div> 

         <div
            class="icon"
            v-if="hyperlink"
        >
            <v-icon
                v-on:click="onClickOpen"
            >
                mdi-open-in-new
            </v-icon>
        </div>
    </div>
</div>
</template>

<script>
const _ = require('lodash');
const Time = require('@/js/time.js');

export default {
    props: {

        label: {
            type: String,
            default: function () { return ''; }
        },

        value: {
            type: [String, Number],
            default: function() { return ''; }
        },

        hint : {
            type: String,
            default: function() { return null; }
        },

        hyperlink: {
            type: Boolean,
            default: function() { return false; }
        },

        copy_check: {
            type: Boolean,
            default: function() { return false; },
        },
    },

    data() {
        return {
            has_copied: false,
        }
    },

    methods: 
    {
        onClickCopy()
        {
            this.has_copied = true;
            let code_span = this.$refs['my_code_block'];

            var range = document.createRange();
            range.selectNode(code_span);
            window.getSelection().removeAllRanges(); // clear current selection
            window.getSelection().addRange(range); // to select text
            document.execCommand("copy");
            window.getSelection().removeAllRanges();// to deselect

            this.$rc.snackbar(this.label+' has been copied to clipboard.',1000);
        },

        onClickOpen()
        {
            window.open(this.value, '_blank');
        },
    },

    computed: {
        copy_icon()
        {
            if ( this.copy_check == true && this.has_copied )
                return 'mdi-check-bold';

            return 'mdi-content-copy';
        }
    },
}
</script>

<style lang="scss" scoped>
.label{
    color: rgba(0,0,0,0.38);
    font-family: Roboto, sans-serif;
    font-size: 12px;
}

.value
{
    margin-bottom: 15px;

    display: flex;
    flex-direction: row;
}

.text
{
     border-bottom: 1px dotted rgba(0,0,0,0.48);
    flex-grow: 1;
}

.icon
{
    margin-left: 12px;
    flex-grow: 0;
}
</style>